<template>
  <div class="member-page">

    <h2 class="title">水枪会员购买</h2>

    <div class="package-list">

      <div
        v-for="item in packages"
        :key="item.month"
        :class="['package', selectedMonth == item.month ? 'active' : '']"
        @click="selectPackage(item)"
      >
        <div class="month">{{item.month}}个月</div>
        <div class="price">￥{{item.price}}</div>
      </div>

    </div>

    <button class="buy-btn" @click="createOrder">
      立即购买
    </button>

  </div>
</template>

<script>
// import axios from '../../utils/request'
export default {

  data () {
    return {
      packages: [
        {month: 1, price: 30},
        {month: 3, price: 80},
        {month: 12, price: 300}
      ],
      selectedMonth: 1,
      selectedPrice: 30
    }
  },
  methods: {
    selectPackage (item) {
      this.selectedMonth = item.month
      this.selectedPrice = item.price
    },

    createOrder: function () {
      this.$router.push({path: '/device/pay',
        query: {
          month: this.selectedMonth,
          price: this.selectedPrice
        }})
    }
  }

}

</script>

<style scoped>

  .member-page{
    width:400px;
    margin:auto;
    text-align:center;
  }

  .title{
    margin:30px 0;
  }

  .package-list{
    display:flex;
    justify-content:space-between;
  }

  .package{
    width:100px;
    border:1px solid #ddd;
    padding:20px;
    cursor:pointer;
    border-radius:8px;
  }

  .package.active{
    border:2px solid #409EFF;
  }

  .month{
    font-size:18px;
    margin-bottom:10px;
  }

  .price{
    font-size:20px;
    color:#ff6600;
  }

  .buy-btn{
    margin-top:40px;
    width:100%;
    height:45px;
    background:#409EFF;
    border:none;
    color:white;
    font-size:16px;
    border-radius:6px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Member.vue